const getMaxBreadcrumbsHeight = (breadcrumbsItem) => breadcrumbsItem.offsetHeight * 2 || null;

const createIntermediateElement = (innerContent) => {
  const intermediateElement = document.createElement('div');
  intermediateElement.style.display = 'flex';
  intermediateElement.style.flexWrap = 'wrap';
  intermediateElement.style.fontSize = window.innerWidth > 479 ? '15px' : '14px';
  intermediateElement.style.width = 'calc(100% - 40px)';
  intermediateElement.innerHTML = innerContent;

  return intermediateElement;
};

const getShortBreadcrumbs = (breadcrumbsWrapper, maxBreadcrumbsHeight) => {
  const breadcrumbsList = breadcrumbsWrapper.querySelectorAll('.bread-crumbs__item');

  if (breadcrumbsList.length) {
    for (let i = 0; i < breadcrumbsList.length; i++) {
      const link = breadcrumbsList[i].querySelector('a');
      if (link) link.innerText = '...';
      if (breadcrumbsWrapper.offsetHeight > maxBreadcrumbsHeight) {
        breadcrumbsWrapper.removeChild(breadcrumbsList[i]);
      } else return breadcrumbsWrapper.innerHTML;
    }
  }
  return breadcrumbsWrapper.innerHTML;
};

const initMobileBreadcrumbs = () => {
  const breadcrumbs = document.querySelector('.bread-crumbs');

  if (window.innerWidth < 768) {
    if (breadcrumbs) {
      const breadcrumbsItems = breadcrumbs.querySelectorAll('.bread-crumbs__item');
      const maxHeight = getMaxBreadcrumbsHeight(breadcrumbsItems[breadcrumbsItems.length - 1]);

      const intermediateElement = createIntermediateElement(breadcrumbs.innerHTML);
      document.body.appendChild(intermediateElement);

      if (intermediateElement.offsetHeight > maxHeight) {
        const elem = getShortBreadcrumbs(intermediateElement, maxHeight);
        breadcrumbs.innerHTML = elem;
      }

      document.body.removeChild(intermediateElement);
    }
  }

  if (breadcrumbs) breadcrumbs.classList.add('_init');
};

initMobileBreadcrumbs();
